import { makeStyles } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import clsx from 'clsx';
import { ReactNode } from 'react';

type Props = { min: ReactNode; max: ReactNode; avg: ReactNode };

const useStyles = makeStyles((theme) => ({
  values: {
    color: grey[400],
    fontSize: 14,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    justifyContent: 'space-between',
  },
  arrow: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  centerText: {
    fontWeight: 'bold',
    color: theme.palette.common.black,
    fontSize: 14,
  },
  centerIcon: {
    fontWeight: 'bold',
    color: theme.palette.common.black,
    fontSize: 13,
  },
}));

const PackageDetailMinMaxRows = ({ min, max, avg }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.values}>
      <div className={classes.row}>
        <span className={classes.arrow}>▲</span>
        {min}
      </div>
      <div className={classes.row}>
        <span className={clsx(classes.centerIcon, classes.arrow)}>&empty;</span>
        <span className={classes.centerText}>{avg}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.arrow}>▼</span>
        {max}
      </div>
    </div>
  );
};

export default PackageDetailMinMaxRows;
